/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { Body } from '@vds/typography';

import { Icon } from '@vds/icons';
import AutoComplete from '../../../common/AutoComplete';

const AddressField = ({ inputLabel, onAddressSelection, onChangeTextBox, addressList, typedValue, helperText, errorState }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (typedValue !== null && typedValue !== undefined) {
      setValue(typedValue);
    }
  }, [typedValue]);

  const onChange = (e) => {
    const addressSelected = addressList?.filter((item) => item.disprawstr === e);
    setValue(e);
    onAddressSelection(e, addressSelected);
  };

  return (
    <>
      <Body primitive="p">{inputLabel}</Body>
      <AutoComplete
        typedValue={value}
        value={value}
        onSelect={(e) => {
          onChange(e);
        }}
        items={addressList}
        onChange={(e) => onChangeTextBox('addressLine1', e)}
        inputProps={{
          className: `autocompleteInput address-autocomplete ${errorState?.value ? 'errorBorder' : ''}`,
          'aria-label': 'Street address',
          id: 'addressLine1',
          name: 'addressLine1',
          itemval: 'disprawstr',
          itemkey: ['locusID', 'muni'],
        }}
      />
      <Body primitive="p" color={!errorState?.value ? '#6F7171' : '#000000'}>
        {errorState?.value && <Icon name="warning" size="l" color="#000000" />}
        {!errorState?.value ? helperText : errorState?.errorText || 'Please enter a valid zipcode'}
      </Body>
    </>
  );
};
export default AddressField;
